export default __webpack_public_path__ + "static/media/8cb75c5ca0420e57f50db101aa33414b.svg";